// Get Tax Class List
export const GET_TAX_CLASS_LIST_REQUEST = 'GET_TAX_CLASS_LIST_REQUEST';
export const GET_TAX_CLASS_LIST_SUCCESS = 'GET_TAX_CLASS_LIST_SUCCESS';
export const GET_TAX_CLASS_LIST_FAIL = 'GET_TAX_CLASS_LIST_FAIL';

// Add Tax Class List
export const ADD_TAX_CLASS_REQUEST = 'ADD_TAX_CLASS_REQUEST';
export const ADD_TAX_CLASS_SUCCESS = 'ADD_TAX_CLASS_SUCCESS';
export const ADD_TAX_CLASS_FAIL = 'ADD_TAX_CLASS_FAIL';
export const UPDATE_TAX_CLASS_STATE = 'UPDATE_TAX_CLASS_STATE';

// Update Tax Class List
export const UPDATE_TAX_CLASS_REQUEST = 'UPDATE_TAX_CLASS_REQUEST';
export const UPDATE_TAX_CLASS_SUCCESS = 'UPDATE_TAX_CLASS_SUCCESS';
export const UPDATE_TAX_CLASS_FAIL = 'UPDATE_TAX_CLASS_FAIL';

// Delete Tax Class List
export const DELETE_TAX_CLASS_REQUEST = 'DELETE_TAX_CLASS_REQUEST';
export const DELETE_TAX_CLASS_SUCCESS = 'DELETE_TAX_CLASS_SUCCESS';
export const DELETE_TAX_CLASS_FAIL = 'DELETE_TAX_CLASS_FAIL';
